/**
 * **Windsurfercrs**
 *
 * @exports bs_9
 * @category engines
 */
function factory({ window, document, thn }) {
    const engine = {};
    const isEliteHotels = thn.data.accountUserId === 1035627;
    let priceUpdate;
    const pidExcludePrice = [
        1015134, // La bellsa
        1016585, 1016580, 1016583, 1016581, 1016582, 1016584, 1016586, 1016070, // Valencia hotel group
    ];
    /**
       * @memberOf module:bs_9
       * @see {@link onStateChange}
       *
       * @param {object} ctx - The context object.
       */
    engine.onStateChange = function onStateChange(ctx) {
        // if (thn.data.accountUserId === 1045119 && !window.location.hostname.includes('booking')) {
        //   setTimeout(thn.languageCheck, 400);
        // }
        // setTimeout(thn.pageCheck, 500);
        if (thn.data.accountUserId === 1045119 && !window.location.hostname.includes('booking')) {
            setTimeout(function () {
                thn.languageCheck().then(function ({ changed }) {
                    if (!changed) {
                        thn.pageCheck();
                    }
                });
            }, 500);
        }
        else {
            setTimeout(thn.pageCheck, 500);
        }
    };
    /**
       * @memberOf module:bs_9
       * @see {@link language_check}
       *
       * @param {object} ctx - The context object.
       */
    engine.languageCheck = function languageCheck(ctx) {
        return new Promise(function (resolve, reject) {
            thn.domReady().then(function () {
                const isTravelodgeAsia = thn.data.accountUserId === 1033788;
                // dictionary for Travelodge Asia
                const langDic = {
                    krw: 'kr',
                    indo: 'id',
                    jap: 'ja',
                    cn: 'zh',
                };
                if (isTravelodgeAsia) {
                    const lang = document.querySelector('#lang')?.value;
                    if (lang && langDic[lang]) {
                        resolve(langDic[lang]);
                        return;
                    }
                }
                if (thn.data.accountUserId === 1045119 && !window.location.hostname.includes('booking')) {
                    const lang = document.documentElement.lang;
                    if (lang && ctx.langs.test(lang)) {
                        resolve(lang);
                        return;
                    }
                }
                reject('no_language');
            });
        });
    };
    /**
       * @memberOf module:bs_9
       * @see {@link onHashChange}
       *
       * @param {object} ctx - The context object.
       */
    engine.onHashChange = function onHashChange(ctx) {
        thn.widgets.price.minimize();
    };
    /**
       * @memberOf module:bs_9
       * @see {@link is_user_logged}
       *
       * @param {object} ctx - The context object.
       */
    engine.isUserLogged = function isUserLogged(ctx) {
        const isLogged = isEliteHotels
            ? (document.querySelector('#MyHeading_lbWelcome') || document.querySelector('#js-manage-button')) // Elite hotels - booking engine and hompage
            : document.querySelector('#buWsProgramMember');
        return !!isLogged;
    };
    /**
       *
       * @memberOf module:bs_9
       * @this thn.widgets.price
       * @see {@link Price#observe_dom}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceObserveDom = function priceObserveDom(ctx) {
        const container = document.querySelector('#dvBody');
        if (container && !priceUpdate) {
            priceUpdate = thn.debounce(() => ctx.widget.update(), 1000);
            thn.observeDom(container, priceUpdate, {
                childList: false,
                subtree: false,
                attributes: true,
            });
            thn.pageUnload(() => {
                priceUpdate.cancel();
                thn.stopObserveDom(container, priceUpdate);
                priceUpdate = null;
            });
        }
        // Add button click listener on currency dropdown selectors
        if (!thn.currencyUndelegate) {
            thn.currencyUndelegate = thn.delegate('click', '#MyHeading_ulWsCurrency a', () => {
                // wait for the select element to show the selected currency
                setTimeout(() => ctx.widget.update(), 500);
            }, true);
        }
        thn.pageUnload(function () {
            // In case were the delegate could not exists
            // we should check if it exists before deleting
            if (thn.currencyUndelegate) {
                thn.currencyUndelegate();
                delete thn.currencyUndelegate;
            }
        });
    };
    /**
       * @memberOf module:bs_9
       * @this thn.widgets.price
       * @see {@link Price#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceParseData = function priceParseData(_ctx) {
        const widgetData = {};
        const isValenciaHotelGroupUser = thn.data.accountUserId === 1034535;
        const isLeCapitalHotelWithLanguage = (thn.data.propertyId === 1040893 && thn.data.language);
        const pacificaHotelPIDs = [1016604, 1016605, 1016607, 1016609, 1016613, 1016610, 1016611, 1016612, 1016614, 1016616, 1016617, 1016618, 1016620, 1016621, 1016622, 1016625, 1016914, 1034764]; // Pacifica hotels except for 1035464
        const isPacificaHotels = pacificaHotelPIDs.includes(thn.data.propertyId);
        const isTheGarlandHotel = thn.data.accountUserId === 1038468;
        const isEliteHotelsInEnglish = thn.data.language === 'en' && isEliteHotels;
        const isWinslowHotels = thn.data.accountUserId === 1045821;
        const isEnsanaHotelsInDifferentFormat = [1046952, 1046941, 1046949].includes(thn.data.propertyId); // there are some properties that have a diffent format for the rates
        //* dates
        const checkinElem = document.querySelector('#spCheckIn')?.value || document.querySelector('#spCheckIn')?.getAttribute('val');
        const checkoutElem = document.querySelector('#spCheckOut')?.value || document.querySelector('#spCheckOut')?.getAttribute('val');
        let dateBegin;
        let dateEnd;
        if (isEliteHotelsInEnglish || (isLeCapitalHotelWithLanguage === 'fr')) {
            dateBegin = checkinElem?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
            dateEnd = checkoutElem?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
        }
        else if (isWinslowHotels || isValenciaHotelGroupUser || (isLeCapitalHotelWithLanguage === 'en')) {
            dateBegin = checkinElem?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$1/$2');
            dateEnd = checkoutElem?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$1/$2');
        }
        else {
            dateBegin = checkinElem?.replace(/-/g, '/');
            dateEnd = checkoutElem?.replace(/-/g, '/');
        }
        if (dateBegin && dateEnd) {
            widgetData.dateBegin = dateBegin;
            widgetData.dateEnd = dateEnd;
        }
        //* guests
        const getInputNum = (selector = '') => thn.parseNumber(document.querySelector(selector)?.value) ?? 0;
        const guestsElem = document.querySelector('#spOccupants')?.textContent?.match(/\d+/g).map(Number);
        widgetData.adults = getInputNum('#cbAdults') || guestsElem?.[1] || 1;
        widgetData.children = getInputNum('#cbChild1') + getInputNum('#cbChild2') + getInputNum('#cbChild3') || guestsElem?.[2] || 0;
        widgetData.guests = widgetData.adults + widgetData.children;
        //* price
        const prices = [];
        const ratesBlacklist = /AAA|AARP|Senior|Government/;
        const pacificaBlacklist = /AAA|AARP|Government/;
        const theGarlandHotelBlacklist = /AAA|AARP|Government|Valley Staycay/;
        const valenciaGroupRatesBlacklist = /AAA|AARP|GOVT/;
        // For Valencia Hotel Group we have to exclude certain prices that we see when displaying their rates for each room.
        // To do this, we will do a more specific iteration for all the prices on the website.
        const roomsSelector = () => {
            if (isValenciaHotelGroupUser || isTheGarlandHotel) {
                return '.ws-rate-data';
            }
            if (isPacificaHotels) {
                return '#dvWsResultRooms .ws-rate-data';
            }
            return '#dvWsResultRooms article';
        };
        const filterFn = isValenciaHotelGroupUser || isPacificaHotels || isTheGarlandHotel || isEnsanaHotelsInDifferentFormat
            ? (rate) => {
                const roomsRatesSelector = '.ws-room-rate-name';
                let excludeBlacklistedRates;
                if (isValenciaHotelGroupUser) {
                    excludeBlacklistedRates = !valenciaGroupRatesBlacklist.test(rate.querySelector(roomsRatesSelector)?.getAttribute('ratecode'));
                }
                else if (isTheGarlandHotel) {
                    excludeBlacklistedRates = !theGarlandHotelBlacklist.test(rate.querySelector(roomsRatesSelector)?.textContent);
                }
                else {
                    excludeBlacklistedRates = !pacificaBlacklist.test(rate.querySelector(roomsRatesSelector)?.textContent);
                }
                return excludeBlacklistedRates;
            }
            : (rate) => {
                const rateName = rate.textContent;
                return thn.isVisible(rate) && (!rateName?.match(/Day Room/i) || (pidExcludePrice.includes(thn.data.propertyId) && ratesBlacklist.test(rateName)));
            };
        const pushPricesFn = (rate) => {
            const price = thn.parseNumber(rate.querySelector('.ws-number')?.textContent);
            if (price) {
                prices.push(price);
            }
        };
        const valenciaHGroupArrPrices = [...document.querySelectorAll(roomsSelector())];
        if (valenciaHGroupArrPrices.length) {
            valenciaHGroupArrPrices.filter(filterFn).forEach(pushPricesFn);
        }
        // some hotels only have package rates : winslow hotels
        const packageRates = [...document.querySelectorAll('#dvWsResultRates .ws-number')].map((packageRate) => thn.isVisible(packageRate) && thn.parseNumber(packageRate?.textContent)).filter(Boolean);
        const shouldUsePackageRates = isWinslowHotels && !thn.empty(packageRates);
        const price = prices.sort((curr, next) => curr - next)[0] || thn.parseNumber(document.querySelector('#txFromRate')?.textContent) || (shouldUsePackageRates && Math.min(...packageRates)) || Math.min(...[...document.querySelectorAll('.ws-item-price')].map((item) => thn.parseNumber(item.textContent)));
        const currency = thn.getCurrencyCode(document.querySelector('#MyHeading_txWsCurrency')?.textContent) || document.querySelector('div.dtSelected > span[curr]')?.getAttribute('curr');
        if (price && currency) {
            widgetData.price = price;
            widgetData.currency = currency;
            widgetData.set = true;
        }
        else if (document.querySelector('.ws-msg-error.ws-show-this') && (widgetData.dateBegin && widgetData.dateEnd)) {
            widgetData.noRooms = true;
        }
        else {
            widgetData.set = false;
        }
        return widgetData;
    };
    /**
       * Does not implement **bookingId**.
       *
       * @memberOf module:bs_9
       * @this thn.widgets.booking
       * @see {@link Booking#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.bookingParseData = function bookingParseData(ctx) {
        const widgetData = {};
        // Early Exit
        // Return empty when it's a page revisit (cancellation)
        if (thn.parseUrlParameter('ret') === 1) {
            this.logger.debug('Booking visits detected as cancellation, not sending booking data');
            widgetData.set = false;
            return widgetData;
        }
        const bookingId = document.querySelector('.ws-confirmation-number');
        widgetData.bookingId = bookingId && bookingId.textContent;
        // price & currency
        const priceSel = document.getElementById('txTotal');
        const currencyEl = thn.dataLayerHelper.get('dsCurrency') || priceSel?.textContent?.split(' ')[1];
        // here we check if the client has booked with POINTS so we assign 0.00001 to the price of booking
        widgetData.price = currencyEl?.toLowerCase().includes('points') ? 0.00001 : thn.parseNumber(priceSel?.textContent);
        widgetData.currency = thn.getCurrencyCode(currencyEl) || ctx.tmpSession.currency || thn.widgets.price.data.currency;
        // dates
        widgetData.dateBegin = (window.WsVars && window.WsVars.YYYYMMDD1 && window.WsVars.YYYYMMDD1.replace(/-/g, '/'));
        widgetData.dateEnd = (window.WsVars && window.WsVars.YYYYMMDD2 && window.WsVars.YYYYMMDD2.replace(/-/g, '/'));
        return widgetData;
    };
    /**
       * @memberOf module:bs_9
       * @see {@link generate_search_url}
       *
       * @param {object} ctx - The context object.
       */
    engine.generateSearchUrl = function generateSearchUrl(ctx) {
        const langDictionary = {
            en: '6',
            de: '4',
            hu: '1',
            ru: '8',
            cs: '12',
            sk: '20',
            ro: '1',
            ar: '14',
        };
        const url = new URL(ctx.baseUrl);
        const validUrlwindsurfer = url.host.match(/windsurfercrs\.com$/);
        const validUrlElite = url.host.match(/bookings\.elite\.se/);
        const validUrlEnsana = url.host.match(/booking\.ensanahotels/);
        // https://booking.ensanahotels.com/ibe/index.aspx?checkin=21/07/2023&checkout=23/07/2023&langID=6&adults=2&rooms=1&currID=2&propertyID=15364
        // https://bookings.elite.se/ibe/index.aspx?pcode=EL030&checkin=13/02/2023&checkout=15/02/2023&rooms=1&adults=1&langID=6&currID=129&promo=MCA
        // https://res.windsurfercrs.com/ibe/index.aspx?locale=en&checkin=10%2F22%2F2020&checkout=10%2F22%2F2020&propertyID=14520&_ga=2.169931688.907410684.1603205651-654816311.1602878960
        // https://lajollacove.windsurfercrs.com/ibe/index.aspx?propertyID=16661&nono=1&checkin=01/01/2023&checkout=01/04/2023&adults=4&_ga=2.31769405.200880949.1669041187-903040592.1669041187&_gl=1*1u0rp4o*_ga*OTAzMDQwNTkyLjE2NjkwNDExODc.*_ga_T0Q1BP9GFD*MTY2OTA0MTE4Ny4xLjEuMTY2OTA0MTIwMy40NC4wLjA.&rooms=2
        if (validUrlwindsurfer || validUrlElite || validUrlEnsana) {
            // prepare URL for params substitution
            url.searchParams.set('checkout', '[date_end]');
            url.searchParams.set('checkin', '[date_begin]');
            url.searchParams.set('adults', '[adults]');
            url.searchParams.set('rooms', '[rooms]');
            url.searchParams.set('promo', '');
            if (validUrlEnsana) {
                const langEl = document.documentElement.lang;
                const langId = langDictionary[langEl];
                url.searchParams.set('langID', langId);
                url.searchParams.delete('viewtype');
                url.searchParams.delete('adult');
                url.searchParams.delete('wh_token');
                url.searchParams.delete('subchan');
                url.searchParams.delete('lang');
                url.searchParams.delete('gclid');
                url.searchParams.delete('dt1');
                url.searchParams.delete('hgID');
                url.searchParams.delete('child1');
            }
            if (validUrlElite || validUrlEnsana) {
                ctx.newData.dateBegin = ctx.newData?.dateBegin?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
                ctx.newData.dateEnd = ctx.newData?.dateEnd?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
            }
            else {
                ctx.newData.dateBegin = ctx.newData?.dateBegin?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$2/$3/$1');
                ctx.newData.dateEnd = ctx.newData?.dateEnd?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$2/$3/$1');
            }
            // export into ctx.new_url
            ctx.newUrl = url.toString();
        }
        else {
            // This is not a valid BE URL
            ctx.newUrl = '';
        }
        return ctx;
    };
    /**
     * @memberOf module:bs_9
     * @this thn.widgets.price
     * @see {@link Price#get_promocode}
     *
     * @param {object} ctx - The context object.
     */
    engine.getPromocode = function getPromocode(ctx) {
        const promocodeEl = document.querySelector('.ws-promoCode');
        const promocode = thn.isVisible(promocodeEl) && promocodeEl?.textContent.trim();
        if (promocode) {
            ctx.promocode = promocode;
        }
        else {
            ctx.promocode = '';
        }
        return ctx.promocode;
    };
    return engine;
}

export { factory };
